import axios from "axios";

export async function getTwitterRedirect(
  username?: string,
  isReconnect = false
): Promise<string> {
  // NOTE: when we pass in username, it forces the user to login and prompts them to use that username
  const params = new URLSearchParams({
    reconnect: String(isReconnect),
  });
  if (username) {
    params.append("username", username);
  }
  const url = `/twitter/request_token?${params.toString()}`;
  const response = await axios.request<string>({ method: "get", url });
  return response.data;
}
